export var VersionEvent;
(function (VersionEvent) {
    VersionEvent["Create"] = "create";
    VersionEvent["Update"] = "update";
    VersionEvent["MarkedAsResolved"] = "marked_as_resolved";
    VersionEvent["MarkedAsUnresolved"] = "marked_as_unresolved";
})(VersionEvent || (VersionEvent = {}));
